import { importAll } from "@/utils";

const requireContext = require.context("@/store/modules", true, /\.js$/);

export default importAll(requireContext, ["index"]);
